import { Box, Stack } from '@mui/material';

import AccountInfo from '../account-info';
import NavList from '../nav-list';

const SiderBarContent = () => {
  return (
    <Stack
      gap={7}
      sx={{
        top: 0,
        left: 0,
        position: 'fixed',
        height: '100vh',
        overflow: 'auto',
        width: 280,
      }}
    >
      <Stack sx={{ px: 2, pt: 2 }}>
        <Box
          component="img"
          alt="logo"
          src="/assets/logo.png"
          sx={{ width: 175, height: 45, objectFit: 'cover' }}
        />
      </Stack>
      <Stack gap={3}>
        <AccountInfo />
        <NavList />
      </Stack>
    </Stack>
  );
};

export default SiderBarContent;
